import { Component, Input } from '@angular/core';

@Component({
  selector: 'rnpl-loader-white',
  templateUrl: './loader-white.component.html',
  styleUrls: ['./loader-white.component.scss']
})
export class LoaderWhiteComponent {
  @Input() greyIcon: boolean = false;
  @Input() hexColor: string = '#FFFFFF';
}
